export function getUIHash() {
    return __webpack_hash__;
}
